var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 40,
    height: 40,
    transform: "translate(173 163)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    transform: "translate(-173 -163)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-home",
    "data-name": "Icon akar-home",
    d: "M25.225,28.654H6.976A3.48,3.48,0,0,1,3.5,25.178V16.4a6.109,6.109,0,0,1,1.893-4.41l8.314-7.9a3.476,3.476,0,0,1,4.788,0l8.312,7.9A6.109,6.109,0,0,1,28.7,16.4v8.776A3.48,3.48,0,0,1,25.225,28.654ZM16.1,4.878a1.731,1.731,0,0,0-1.2.478l-8.314,7.9A4.364,4.364,0,0,0,5.238,16.4v8.776a1.74,1.74,0,0,0,1.738,1.738H25.225a1.74,1.74,0,0,0,1.738-1.738V16.4a4.364,4.364,0,0,0-1.352-3.15L17.3,5.356A1.731,1.731,0,0,0,16.1,4.878Z",
    transform: "translate(176.887 166.252)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.292e3dcc60f7ac00018f836df4b506db.svg";
export { ForwardRef as ReactComponent };